import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/jobs/$jobId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: `/jobs/${params.jobId}/overview`,
    })
  },
})
